export const footerUrls = {
    SUPPORT_UPDATES: 'https://notifications.tolunastart.com',
    SOLUTIONS: 'https://tolunacorporate.com/our-solutions',
};

export const cookieUrls = {
    DE: 'https://tolunacorporate.com/legal/your-cookies/?lang=de',
    FR: 'https://tolunacorporate.com/legal/politique-relative-a-lutilisation-des-cookies/?lang=fr',
    PT: 'https://tolunacorporate.com/legal/cookies/?lang=pt-br',
    DEFAULT: (culture: string) => `https://tolunacorporate.com/legal/cookies/?lang=${culture}`,
};

export const externalUrls = {
    PROJECT: 'Project',
    REPORTS: 'Reports',
};

export const WALKME_SCRIPT_ID = 'TS_WalkMe_Script';
export const WALKME_COOKIE_NAME = 'Enable_Walkme';

export const walkMeKeys = {
    PROD: 'https://eu-cdn.walkme.com/users/0090debf1f6a4b4da10a010e4a786a56/walkme_0090debf1f6a4b4da10a010e4a786a56_https.js',
    TRN: 'https://eu-cdn.walkme.com/users/0090debf1f6a4b4da10a010e4a786a56/trn/walkme_0090debf1f6a4b4da10a010e4a786a56_https.js',
};

export const tcpConfigs = {
    INIT_OPTIONS: {
        advancedFeatures: {
            renderIndications: true,
        },
    },
};
export const envUrls = {
    PROD: 'https://tim.ti.tolunainsights.com/api/v1/',
    TRN: 'https://tim.ti.tolunainsights-trn.com/api/v1/',
    PROD_TS: 'https://tim.tolunastart.com/api/v1/',
    TRN_ALIAS_TS: 'https://tim.trn.tolunastart.com/api/v1/',
    TRN_TS: 'https://tim.tolunastart-trn.com/api/v1/',
};

export const defaultOptions = {
    advancedFeatures: {
        renderIndications: true,
    },
};

export enum ELicenseStatus {
    ACTIVE,
    DE_ACTIVE,
    NO_STATUS,
}
